import * as tslib_1 from "tslib";
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { getErrorCode } from '@core/utils/get-error-code';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { UserLookupService } from '../../services/api/user-lookup.api.service';
import { LoginResolver } from '../../services/login.resolver';
var LoginRecoverPasswordComponent = /** @class */ (function () {
    function LoginRecoverPasswordComponent(router, loginResolver, activatedRoute, userLookupService, fuseProgressBar, authenticationService) {
        this.router = router;
        this.loginResolver = loginResolver;
        this.activatedRoute = activatedRoute;
        this.userLookupService = userLookupService;
        this.fuseProgressBar = fuseProgressBar;
        this.authenticationService = authenticationService;
        this.isLoading = false;
        this.loginCustomization = this.loginResolver.loginCustomization;
        this.emailControl = new FormControl(this.activatedRoute.snapshot.queryParams.email, [
            Validators.required, Validators.email
        ]);
    }
    LoginRecoverPasswordComponent.prototype.recoverAccount = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var email, lookupResult, err_1, code;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoading = true;
                        this.fuseProgressBar.show();
                        email = this.emailControl.value.trim();
                        this.emailControl.markAsTouched();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 6]);
                        return [4 /*yield*/, this.userLookupService.lookupUserByEmail(email)];
                    case 2:
                        lookupResult = _a.sent();
                        if (lookupResult.loginIntegrationEnabled) {
                            this.emailControl.setErrors({ loginIntegrationEnabled: true });
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.authenticationService.sendPasswordRecoveryEmail(email)];
                    case 3:
                        _a.sent();
                        this.router.navigateByUrl("/login/recuperar-senha/" + email);
                        return [3 /*break*/, 6];
                    case 4:
                        err_1 = _a.sent();
                        code = getErrorCode(err_1);
                        if (code === 'UserNotFoundException') {
                            this.emailControl.setErrors({ userNotFound: true });
                            return [2 /*return*/];
                        }
                        if (code === 'LimitExceededException') {
                            this.emailControl.setErrors({ attemptsExceed: true });
                            return [2 /*return*/];
                        }
                        if (err_1.error.message === 'User is disabled') {
                            this.emailControl.setErrors({ userDisabled: true });
                            return [2 /*return*/];
                        }
                        this.emailControl.setErrors({ unknown: true });
                        return [3 /*break*/, 6];
                    case 5:
                        this.isLoading = false;
                        this.fuseProgressBar.hide();
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    return LoginRecoverPasswordComponent;
}());
export { LoginRecoverPasswordComponent };
